var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 94 81",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.222 5.557l-1.299-2.25-1.299 2.25L4.387 76.98l-1.299 2.25h87.67l-1.299-2.25L48.222 5.557z",
    stroke: "#fff",
    strokeWidth: 2,
    vectorEffect: "non-scaling-stroke"
  })));
}
export default SvgTriangle;